<template>
  <div id="bubblePackChart" v-if="series.length!=0">
    <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts>
    <div style="margin-top:-15px; padding: 0 5px;">
      <v-range-slider
        v-model="bubbleRange"
        :max="max"
        :min="min"
        hide-details
        class="align-center"
      >
        <template v-slot:prepend>
          <v-text-field
            :value="bubbleRange[0]"
            class="pt-0"
            hide-details
            single-line
            solo
            dense
            type="number"
            style="width: 80px; margin-top:-10px;"
            @change="$set(bubbleRange, 0, $event)"
          ></v-text-field>
        </template>
        <template v-slot:append>
          <v-text-field
            :value="bubbleRange[1]"
            class="pt-0"
            hide-details
            single-line
            solo
            dense
            type="number"
            style="width: 80px; margin-top:-10px;"
            @change="$set(bubbleRange, 1, $event)"
          ></v-text-field>
        </template>
      </v-range-slider>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    series:{
      type: Array
    }
  },
  mounted(){
    let res=[];
    this.series.forEach(x => {x.data.forEach(y=>res=res.concat(y.value))})
    this.min= Math.min(...res)
    this.max= Math.max(...res)
    this.bubbleRange=[this.min,this.max]
  },
  watch:{
    bubbleRange(){
      let res = []
      this.filteredSeries=this.series.forEach((x,i) => {res[i]={data:(x.data.filter(y => y.value >= this.bubbleRange[0] && y.value <= this.bubbleRange[1] )),name:this.series[i].name}});
      this.chartOptions.series=res;
    }
  },
  data() {
    return {
      min:0,
      max:0,
      bubbleRange:[0,1],
      chartOptions: {
        chart: {
          type: "packedbubble",
          height: "290"
        },
        title:{
          text:null
        },
        colors: ['#00E396','#FF4560','#FEB019'],
        tooltip: {
            formatter: function() {
              var r=this.point.name.split('    ')
              return '<b>'+ r[0]+'</b><br>'+ r[1] + '.<br><b>' + this.y + ' retweets</b>';
            }
        },
        plotOptions: {
          packedbubble: {
            minSize: '10%',
            maxSize: '150%',
            layoutAlgorithm: {
              splitSeries: false,
              gravitationalConstant: 0.02
            },
            dataLabels: {
              enabled: true,

              style: {
                color: 'black',
                textOutline: 'none',
                fontWeight: 'normal',
              }
            }
          }
        },
        series: this.series
      },
      filteredSeries:this.series
    };
  },
};
</script>
<style>

</style>
